<template>
  <div class="container" id="jump1">
    <!-- 顶部导航栏 -->
    <HeadTab :typeindex="0"></HeadTab>
    <img class="opl" src="/static/img/Mask_group.png" alt="" />
    <div class="obtain">
      <div class="document_inner">
        <div class="document_left">
          <div class="ikd">
            <div class="breadcrumb"  @click="$router.push('/')">Главная страница</div>
            <img class="mle" src="/static/img/jt.png" alt="" />
            <div class="njk">документ</div>
          </div>
          <div class="document_title">Документы</div>
          <div class="document_card">
            <div class="document_card-title">ВАЖНЫЕ ДОКУМЕНТЫ</div>
            <div class="document_item" v-for="(item,index) in documentList" :key="index" @click="getdocum(item.link)">
              <div class="document_item-text">{{ item.title }}</div>
              <div class="document_item-arrow">›</div>
            </div>
          </div>
        </div>
        <div class="document_right">
          <LoanCard :initial-amount="100000" :repay-amount="101000"></LoanCard>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="1"></BomTab>
  </div>
</template>

<script>
  import HeadTab from '@/components/HeadTab.vue'
  import BomTab from '@/components/BomTab.vue'
  import LoanCard from '@/components/loancard.vue'
  export default {
    name: "conte",
    data() {
      return {
        documentList: [
          { title: 'Политика конфиденциальности' ,
          link: 'https://kzcredit.kz/CreditContract/personaldata.html'},
          { title: 'ПУБЛИЧНАЯ ОФЕРТА',
          link: 'https://kzcredit.kz/CreditContract/publicoffer.html'},
          { title: 'Пользовательское соглашение',
          link: 'https://kzcredit.kz/CreditContract/consenttocollection.html'},
          { title: 'Микрокредитная финансовая лицензия',
          link: 'https://kzcredit.kz/licenseplate.pdf'}
        ]
      };
    },
    components: {
      BomTab,
      HeadTab,
      LoanCard
    },
    mounted () {
    },
    methods: {
      getdocum(e){
        location.href = e
      }
    },
  };
</script>

<style scoped>
  .opl{
    width: 3.29rem;
    height: 1.82rem;
    position: absolute;
    top: 0.57rem;
    left: 0;
    z-index: 0;
  }
  .obtain {
    background: rgba(244, 247, 250, 1);
    padding: 0.78rem 1.58rem 1.4rem;
  }
  .document_inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.94rem;
  }
  .document_left {
    width: 3.11rem;
  }
  .ikd{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.17rem;
  }
  .breadcrumb {
    color: rgba(148, 163, 184, 1);
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.07rem;
    cursor: pointer;
    z-index: 999999;
  }
  .mle {
    width: 0.1rem;
    height: fit-content;
    margin: 0.03rem 0.01rem 0;
  }
  .njk{
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.07rem;
  }
  .document_title {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.21rem;
    margin-bottom: 0.17rem;
  }
  .document_card {
    border-radius: 0.08rem;
    background: rgba(255, 255, 255, 1);
    padding: 0.13rem;
  }
  .document_card-title {
    color: rgba(0, 102, 204, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.1rem;
    text-transform: uppercase;
    margin-bottom: 0.13rem;
  }
  .document_item {
    height: 0.32rem;
    border-radius: 0.08rem;
    background: rgba(248, 248, 248, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.08rem 0.13rem;
    margin-bottom: 0.08rem;
    cursor: pointer;
  }
  .document_item:last-child {
    margin-bottom: 0;
  }
  .document_item-text {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.09rem;
  }
  .document_item-arrow {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.13rem;
    line-height: 1;
  }
  .document_right {
    width: 2.78rem;
  }

  @media screen and (max-width: 1200px) {
    .obtain {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .document_inner {
      gap: 0.24rem;
    }
    .document_left,
    .document_right {
      width: 50%;
    }
  }

  @media screen and (max-width: 768px) {
    .opl{
      width: 2.29rem;
      height: 1.32rem;
      position: absolute;
      top: 0.95rem;
      left: 0;
    }
    .obtain {
      padding-top: 0.42rem;
      padding-bottom: 0.48rem;
    }
    .document_inner {
      flex-direction: column;
    }
    .document_left,
    .document_right {
      width: 100%;
    }
    .document_title {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/conte.vue